import { autobind } from 'core-decorators'
import * as React from 'react'
import { Jaw } from '../../../../../../shared/Constants'
import { JawReplacementConfigView } from './JawReplacementConfigView'
import { JawReplacementRecommendationOverview } from './JawReplacementRecommendationOverview'

interface IProps {
  jaw: Jaw
  onRequirementsChanged?: () => any
  onConfiguringReplacementChanged?: (state: boolean) => any
}

interface IState {
  configuring: boolean
}

export class JawReplacementRecommendationView extends React.Component<IProps, IState> {
  state: IState = {
    configuring: false
  }

  // -------------------------------------------------------------------------- HELPERS

  @autobind
  private _switchToConfig () {
    this.setState({ configuring: true })
    this.props.onConfiguringReplacementChanged?.(true)
  }

  @autobind
  private _switchToRecommendation () {
    this.setState({ configuring: false })
    this.props.onConfiguringReplacementChanged?.(true)
    this.props.onRequirementsChanged?.()
  }

  // -------------------------------------------------------------------------- RENDERING

  private _renderContent () {
    const { configuring } = this.state
    const { jaw } = this.props

    return configuring
      ? <JawReplacementConfigView jaw={jaw} onSwitchToRecommendation={this._switchToRecommendation} />
      : <JawReplacementRecommendationOverview jaw={jaw} onSwitchToConfig={this._switchToConfig} />
  }

  render (): React.ReactNode {
    return this._renderContent()
  }
}
